import { render } from "./Hosts.vue?vue&type=template&id=797a5ab0"
import script from "./Hosts.vue?vue&type=script&lang=ts"
export * from "./Hosts.vue?vue&type=script&lang=ts"
script.render = render

export default script